import { emitter } from 'shared/helpers/mitt';
import analyticsHelper from 'dashboard/helper/AnalyticsHelper/index';

/**
 * Custom hook to track events
 */
export const useTrack = (...args) => {
  try {
    return analyticsHelper.track(...args);
  } catch (error) {
    // Ignore this, tracking is not mission critical
  }

  return null;
};

/**
 * Composable for showing toast/alert messages.
 * @returns {Object} An object with showAlert method
 */
export const useAlert = () => {
  const showAlert = (message, action = null) => {
    emitter.emit('newToastMessage', { message, action });
  };

  return {
    showAlert,
  };
};
